// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeChatDeleteForMeBody = {
  chatId: string;
};

export type typeChatDeleteForMeOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { chatId: string; clearedAtIso: string };
};

export type typeChatDeleteForMeOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatDeleteForMeOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatDeleteForMeOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaChatDeleteForMeBody = {
  type: "object",
  properties: { chatId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["chatId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createChatDeleteForMe(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaChatDeleteForMeBody);
  }

  return async function postChatDeleteForMe(
    payload: typeChatDeleteForMeBody,
  ): Promise<typeChatDeleteForMeOutput200 | typeChatDeleteForMeOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postChatDeleteForMe" failed before calling the network. #9a244b048505`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#9a244b048505" },
        },
        data: null,
      } as typeChatDeleteForMeOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/chat/delete-for-me`,
      httpMethod: "POST",
      options,
    })) as typeChatDeleteForMeOutput200 | typeChatDeleteForMeOutput400;
  };
}
